import React from 'react'

const THCRedTemplate = (props) => {
    console.log(props)
    let thcBevs = props.thcMenu.items
    let redWine = props.redWine.items

    return(
        <div className="thc-red-page">
            THC Red Page goes here. 
        </div>
    )
}
export default THCRedTemplate